import React, { FunctionComponent } from 'react';
import { FormFieldProps } from '../FormFieldDisplay';

const SpacerFormField: FunctionComponent<FormFieldProps> = () => {
    return <br />;
};

export default SpacerFormField;
